<div class="mb-4">
  <xena-checkbox *ngFor="let term of items"
    [checked]="term.isSelected"
    (checkedChange)="onSelect($event.detail, term)">
    <span i18n="@@createFiscal_step3_i_have_read_and_agree_to">I have read and agreed to</span>&nbsp;<a [href]="term.url" target="_blank">{{ term.description }}</a>
  </xena-checkbox>
</div>
